import FieldCheckbox from './FieldCheckbox';
import FieldController from './FieldController';
import FieldFormHelperText from './FieldFormHelperText';
import FieldFormLabel from './FieldFormLabel';
import FieldInputLabel from './FieldInputLabel';
import FieldOutlinedInput from './FieldOutlinedInput';
import FieldPhoneNumberInput from './FieldPhoneNumberInput';
import FieldRadio from './FieldRadio';
import FieldSelect from './FieldSelect';
import FieldSwitch from './FieldSwitch';

const Field = {
  Controller: FieldController,
  FormLabel: FieldFormLabel,
  InputLabel: FieldInputLabel,
  OutlinedInput: FieldOutlinedInput,
  Checkbox: FieldCheckbox,
  Switch: FieldSwitch,
  Radio: FieldRadio,
  Select: FieldSelect,
  FormHelperText: FieldFormHelperText,
  PhoneNumberInput: FieldPhoneNumberInput,
};

export default Field;
